import { render, staticRenderFns } from "./PowerImitateLeft.vue?vue&type=template&id=3005a93d&scoped=true"
import script from "./PowerImitateLeft.vue?vue&type=script&lang=js"
export * from "./PowerImitateLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3005a93d",
  null
  
)

export default component.exports